const messages = {
  title: "Informacije o proizvodu i odobrenja",
  description:
    "Dobrodošli u sekciju brošura i cjenovnika oko proizvoda Bridgestone i Firestone. Ovdje možete pronaći aktualne brošure i cjenovnike za sve proizvodne oblasti i Pricat datoteke za vaše upravljanje zalihama.",
};
export default {
  messages,
};
